import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "sa_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  setToken(data.access_token);
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/admin/me`, authHeaders());
  return data;
};

export const adminStats = async () => {
  const { data } = await axios.get(`${API}/admin/stats`, authHeaders());
  return data;
};

export const adminBookings = async () => {
  const { data } = await axios.get(`${API}/bookings`, authHeaders());
  return data;
};

export const adminAssessments = async () => {
  const { data } = await axios.get(`${API}/admin/assessments`, authHeaders());
  return data;
};

export const adminAssessmentDetail = async (id) => {
  const { data } = await axios.get(`${API}/admin/assessments/${id}`, authHeaders());
  return data;
};

export const adminUpdateFollowup = async (id, payload) => {
  const { data } = await axios.patch(`${API}/admin/assessments/${id}/followup`, payload, authHeaders());
  return data;
};

export const adminAssessmentsExport = async () => {
  const { data } = await axios.get(`${API}/admin/assessments-export`, authHeaders());
  return data;
};

export const adminPayments = async () => {
  const { data } = await axios.get(`${API}/admin/payments`, authHeaders());
  return data;
};

export const listPromos = async () => {
  const { data } = await axios.get(`${API}/admin/promos`, authHeaders());
  return data;
};

export const createPromo = async (payload) => {
  const { data } = await axios.post(`${API}/admin/promos`, payload, authHeaders());
  return data;
};

export const updatePromo = async (id, payload) => {
  const { data } = await axios.patch(`${API}/admin/promos/${id}`, payload, authHeaders());
  return data;
};

export const deletePromo = async (id) => {
  const { data } = await axios.delete(`${API}/admin/promos/${id}`, authHeaders());
  return data;
};

export const getImpactStats = async () => {
  const { data } = await axios.get(`${API}/impact-stats`);
  return data;
};

export const updateImpactStats = async (payload) => {
  const { data } = await axios.patch(`${API}/admin/impact-stats`, payload, authHeaders());
  return data;
};

export const adminOtpStats = async () => {
  const { data } = await axios.get(`${API}/admin/otp-stats`, authHeaders());
  return data;
};

export const adminProgramInterest = async () => {
  const { data } = await axios.get(`${API}/admin/program-interest`, authHeaders());
  return data;
};

export const adminOryven = async () => {
  const { data } = await axios.get(`${API}/admin/oryven`, authHeaders());
  return data;
};


export const updateBookingStatus = async (id, status) => {
  const { data } = await axios.patch(
    `${API}/bookings/${id}/status`,
    { status },
    authHeaders()
  );
  return data;
};

export const adminWaResend = async (assessmentId) => {
  const { data } = await axios.post(
    `${API}/admin/assessments/${assessmentId}/whatsapp/resend`,
    {},
    authHeaders()
  );
  return data;
};

export const adminWaTest = async (phone, band) => {
  const { data } = await axios.post(
    `${API}/admin/whatsapp/test`,
    { phone, band },
    authHeaders()
  );
  return data;
};

export const downloadCSV = (filename, rows, columns) => {
  const esc = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map((c) => esc(c.label)).join(",");
  const body = rows
    .map((r) => columns.map((c) => esc(r[c.key])).join(","))
    .join("\n");
  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
